<template>
  <v-card
    class="pa-0 ma-0 justify-center preview-container"
    flat
  >
    <v-card-title class="px-4 pb-2">
      <v-layout row wrap>
        <v-flex xs12>
          <location-targeting-component
            @update="update"
            @updateIsLoadingTargeting="updateIsLoadingTargeting"
          />
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-spacer />
    <v-card-actions class="py-0 pb-2 card-actions">
      <v-flex xs12 :class="{'ml-3':!$vuetify.breakpoint.xsOnly}">
        <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
          <v-flex :class="{ 'shrink mr-2': !$vuetify.breakpoint.xsOnly, 'xs12': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              color="primary"
              @click="closeAdDetailsDialog()"
              :loading="isLocationTargetingLoading"
              :disabled="isBtnDisabled"
            >
              <span class="text-capitalize"> {{ $t('message.done') }}</span>
            </v-btn>
          </v-flex>
          <v-flex :class="{ 'shrink ml-2': !$vuetify.breakpoint.xsOnly, 'xs12 mb-2': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              color="primary"
              outline
              v-if="!$vuetify.breakpoint.xsOnly"
              @click="closeDialog()"
            >
              {{ $t('message.bizgainOnboarding.discard') }}
            </v-btn>
            <span class="text-xs-center font-bold" @click="closeDialog()" v-else>
              <a
                class="text-xs-center my-1"
              > {{ $t('message.bizgainOnboarding.discard') }}</a>
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  VCard,
  VCardTitle,
  VCardActions,
  VLayout,
  VFlex,
  VSpacer
} from 'vuetify/lib';
import { targetType } from 'Features/bizgainOnboarding/constants';
import LocationTargetingComponent from 'Components/LocationTargetingComponent/LocationTargetingComponent.vue';

export default {
  components: {
    VCard,
    VCardTitle,
    VCardActions,
    VLayout,
    VFlex,
    VSpacer,
    LocationTargetingComponent
  },
  props: {
    fromSummary: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isRegionTargeting() {
      return this.targetingType == this.targetType.region;
    },
    isBtnDisabled() {
      return this.isRegionTargeting && this.selectedSpecificLocations.length <= 0 || this.isLocationTargeting && !this.location
    }
  },
  data() {
    return {
      targetType,
      targetingType: null,
      selectedSpecificLocations: [],
      location: null,
      isLocationTargetingLoading: false
    }
  },
  methods: {
    closeAdDetailsDialog(){
      this.isLocationTargetingLoading = true;
      this.$emit('update');
    },
    closeDialog(){
      this.$emit('closeDialog');
    },
    update(details){
      this.targetingType = details.targetingType;
      this.location = details.location;
      this.selectedSpecificLocations = details.selectedSpecificLocations;
      this.$emit('updateLocationtargetingDetails', details);
    },
    updateIsLoadingTargeting(value){
      this.$emit('updateIsLoadingTargeting', value);
    }
  }
}
</script>

<style lang="scss" scoped>
.font-bold{
  font-weight: 500;
}
</style>